export const BRAND_LOGO_TEXT = {
  alt: 'D3',
} as const;
